import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import app from "./modules/app";
import data from "./modules/data";
import getters from "./getters";
import permission from "./modules/permission";
import dashboard from "./modules/dashboard";
import settings from "./modules/settings";
import user from "./modules/user";
import users from "./modules/users";
import activity from "./modules/activity";

Vue.use(Vuex);

// eslint-disable-next-line no-unused-vars
const dataState = createPersistedState({
  paths: ["data", "user", "users", "activity"],
});

const store = new Vuex.Store({
  modules: {
    app,
    permission,
    dashboard,
    user,
    settings,
    users,
    data,
    activity,
  },
  getters,
  plugins: [dataState],
});

export default store;
